export default __webpack_public_path__ + "static/media/closer.b5a0968c.jpg";